import { useState, useEffect, useRef } from 'react';
import classnames from 'classnames';
import getVideoId from 'get-video-id';
import { useClickAway } from 'react-use';

import styles from './index.css';

export interface VideoProp {
    className?: string;
    src: string;
    onClickOutside?: () => void;
}

const Video: React.FC<VideoProp> = ({ className, src = '', onClickOutside = () => {} }) => {
    const ref = useRef(null);
    useClickAway(ref, onClickOutside);

    const [iframeSrc, setIframeSrc] = useState('');

    useEffect(() => {
        const { id, service } = getVideoId(src);

        if (service === 'youtube') {
            setIframeSrc(`https://www.youtube.com/embed/${id}`);
        } else if (service === 'vimeo') {
            setIframeSrc(`https://player.vimeo.com/video/${id}`);
        } else {
            setIframeSrc('');
        }
    }, [src]);

    return (
        <div className={classnames(styles.video, className)}>
            <div ref={ref} className={styles.sizeContainer}>
                <div className={styles.rwdContainer}>
                    <iframe title="video" src={iframeSrc} frameBorder={0} />
                </div>
            </div>
        </div>
    );
};

export default Video;
